import React, { useEffect, useState } from "react";
import { masterAPI } from "../../../Masters/dataConfig";
import { axiosPrivate } from "../../../../axios/axios";
import { Box, CircularProgress, Dialog, Divider, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import { color } from "../../../../StyleData/Config";
import { Clear, Domain, EditOutlined } from "@mui/icons-material";
import NormalTable from "../../../../Component/NormalTable";
import CreatePart from "./CreatePart";

const Partlist = ({ workOrderId, enableDisable, woStatus, refreshWoStatus }) => {
  const [partList, setPartList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [partDialogue, setPartDialogue] = useState(false);
  const [editData, setEditData] = useState(null);
  const [viewDialogue, setViewDialogue] = useState(false);
  const [viewItems, setViewItems] = useState([]);
  const [viewCode, setViewCode] = useState("");

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setLoading(true);
    try {
      let getPartlistlink = masterAPI["partsReservation"].getByWorkOrderId;
      let response = await axiosPrivate.get(`${getPartlistlink}/${workOrderId}`);

      setPartList(Array.isArray(response.data.result) ? response.data.result : []);
    } catch (error) {
      setPartList([]);
    }
    setLoading(false);
  };

  const handleCodeClick = (row) => {
    setViewItems(row.partsReservationItemsList || []);
    setViewCode(row.code);
    setViewDialogue(true);
  };

  const itemColumns = [
    {
      Header: "Part Code",
      accessor: "partCode",
    },
    {
      Header: "Part Name",
      accessor: "partName",
    },
    {
      Header: "Stock Room",
      accessor: "stockRoomName",
    },
    {
      Header: "Quantity",
      accessor: "quantity",
    },
  ];

  const partsColumns = [
    {
      Header: "Code",
      accessor: "code",
      Cell: ({ row }) => (
        <Typography
          sx={{
            color: "#0d6efd",
            fontSize: "inherit",
            fontWeight: 600,
            cursor: "pointer",
          }}
          onClick={() => handleCodeClick(row.original)}
        >
          {row.original.code}
        </Typography>
      ),
    },
    {
      Header: "Status",
      accessor: "status",
    },
    {
      Header: "Remarks",
      accessor: "comments",
      Cell: ({ row }) =>
        row.original.status?.toUpperCase() === "REJT"
          ? row.original.comments || "---"
          : "---",
    },
    // {
    //   Header: "Current Work Flow",
    //   accessor: "currentWorkFlow",
    // },
    {
      Header: "Actions",
      Cell: ({ row }) => {
        const editStatus = row.original.status?.toUpperCase();
        const editDisabled =
          (editStatus !== "PPRAPPR" && editStatus !== "REJT" && editStatus !== "OPEN") ||
          woStatus?.toUpperCase() === "CLOSE";
          // enableDisable?.part?.edit === false;
        return (
          <Box sx={{ whiteSpace: "nowrap" }}>
            <IconButton
              disabled={editDisabled}
              onClick={() => {
                setEditData(row.original);
                setPartDialogue(true);
              }}
            >
              <EditOutlined
                sx={{
                  fontSize: color.masterEditDelButton,
                  color: editDisabled ? "default" : color.masterEditDelButtonColor,
                }}
              />
            </IconButton>
          </Box>
        );
      },
    },
  ];

  const handlePartClose = () => {
    setPartDialogue(false);
    setEditData(null);
    getData();
    if (refreshWoStatus) refreshWoStatus();
  };

  const showPartIcon = woStatus?.toUpperCase() !== "PPRAPPR";

  return (
    <>
      {loading ? (
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}><CircularProgress /></Box>
      ) : (
        <Grid container gap={"1rem"}>
          <Grid item xs={12} sx={{ boxShadow: "-1px 1px 7px 2px rgb(0 0 0 / 32%)", p: 1.5, backgroundColor: "white" }}>
            <Grid container alignItems={"center"} sx={{ mb: "0.5rem" }}>
              <Grid item xs={3}>
                <Typography sx={{ color: color.masterDialogTitleColor, fontSize: color.masterDialogFontSize }}>
                  Part
                </Typography>
              </Grid>
              <Grid container item xs={9} justifyContent={"flex-end"} gap={"1rem"}>
                {showPartIcon && (
                  <Tooltip title="Parts">
                    <IconButton
                      disabled={enableDisable?.part?.create === false}
                      onClick={() => setPartDialogue(true)}
                    >
                      <Domain sx={{ fontSize: "1.7rem" }} />
                    </IconButton>
                  </Tooltip>
                )}
              </Grid>
            </Grid>
            <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
            <NormalTable columns={partsColumns} data={partList} />
          </Grid>
        </Grid>
      )}
      <Dialog
        open={partDialogue}
        onClose={handlePartClose}
        fullWidth
        maxWidth={"lg"}
      >
        <CreatePart handleCloseClick={handlePartClose} workOrderId={workOrderId} editData={editData} />
      </Dialog>
      <Dialog
        open={viewDialogue}
        onClose={() => setViewDialogue(false)}
        fullWidth
        maxWidth={"md"}
      >
        <Box sx={{ p: 2 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: "0.5rem" }}>
            <Typography sx={{ color: color.masterDialogTitleColor, fontSize: color.masterDialogFontSize }}>
              Part List {viewCode ? `- ${viewCode}` : ""}
            </Typography>
            <IconButton onClick={() => setViewDialogue(false)}>
              <Clear />
            </IconButton>
          </Box>
          <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
          <NormalTable columns={itemColumns} data={viewItems} />
        </Box>
      </Dialog>
    </>
  );
};

export default Partlist;
